import React from 'react';
import { Typography, List, ListItem, ListItemText, Divider } from '@mui/material';

const DataSubjectResponsibilities: React.FC = () => {
  const candidateResponsibilities = [
    "Ler atentamente esta declaração de privacidade.",
    "Se você é ou foi candidato em algum dos nossos processos seletivos e nos forneceu informações pessoais sobre outras pessoas, como contatos de referências pessoais, por exemplo, só usaremos essas informações para o motivo específico pelo qual nos foram fornecidas. Ao enviar as informações, você confirma que nos autoriza a processá-las em seu nome, de acordo com esta Declaração de Privacidade.",
    "Se você enviar, apresentar ou informar seus dados você confirma que autoriza e dá o consentimento para tratá-los em seu nome de acordo com essa Declaração de Privacidade para a finalidade do processo de recrutamento e seleção e rotinas pré-contratuais.",
    "Autorizar também eventual compartilhamento das empresas que auxiliam a INNOVA PLANO DE SAÚDE no processo de seleção e recrutamento."
  ];

  const clientResponsibilities = [
    "Ler atentamente esta declaração de privacidade.",
    "Verificar também que os contratos entre as partes possuem cláusulas específicas sobre adequação à LGPD, exigências e detalhes sobre como coletamos e processamos seus dados."
  ];

  return (
    <div>
      <Typography variant="h4" gutterBottom>
        10. Quais as minhas responsabilidades como candidato, cliente, beneficiário, conveniado, dependente, visitante, fornecedor ou outro titular de dados?
      </Typography>

      <Typography variant="h6" gutterBottom>
        Candidato:
      </Typography>
      <List>
        {candidateResponsibilities.map((responsibility, index) => (
          <React.Fragment key={index}>
            <ListItem>
              <ListItemText primary={responsibility} />
            </ListItem>
            {index < candidateResponsibilities.length - 1 && <Divider />}
          </React.Fragment>
        ))}
      </List>

      <Typography variant="h6" gutterBottom>
        Cliente, Usuário, Conveniado e Fornecedor:
      </Typography>
      <List>
        {clientResponsibilities.map((responsibility, index) => (
          <React.Fragment key={index}>
            <ListItem>
              <ListItemText primary={responsibility} />
            </ListItem>
            {index < clientResponsibilities.length - 1 && <Divider />}
          </React.Fragment>
        ))}
      </List>
    </div>
  );
};

export default DataSubjectResponsibilities;
